module.exports = __webpack_public_path__ + "img/useFlow-small-bg1.a83ae3a.png";